module.exports = require("perf_hooks");